var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationadmin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.77956 8.73114C8.89614 8.73114 9.8013 7.82277 9.8013 6.70224C9.8013 5.58171 8.89614 4.67334 7.77956 4.67334C6.66298 4.67334 5.75781 5.58171 5.75781 6.70224C5.75781 7.82277 6.66298 8.73114 7.77956 8.73114Z",
    stroke: "#3F3F3F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.3448 5.51872C3.62136 -0.112786 11.9351 -0.106283 13.2052 5.52522C13.9504 8.82869 11.9027 11.6249 10.1078 13.3547C8.80532 14.6163 6.74469 14.6163 5.43574 13.3547C3.64728 11.6249 1.59961 8.82219 2.3448 5.51872Z",
    stroke: "#3F3F3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationadmin);
export default __webpack_public_path__ + "static/media/locationadmin.de262d5c35f54d05eb581b8d59089554.svg";
export { ForwardRef as ReactComponent };